__turbopack_context__.v({
  "centered": "spinner-module-scss-module__cxcG8G__centered",
  "currentColor": "spinner-module-scss-module__cxcG8G__currentColor",
  "error": "spinner-module-scss-module__cxcG8G__error",
  "isInline": "spinner-module-scss-module__cxcG8G__isInline",
  "onColor": "spinner-module-scss-module__cxcG8G__onColor",
  "overlay": "spinner-module-scss-module__cxcG8G__overlay",
  "overlayTextContainer": "spinner-module-scss-module__cxcG8G__overlayTextContainer",
  "primary": "spinner-module-scss-module__cxcG8G__primary",
  "rotateClockwise": "spinner-module-scss-module__cxcG8G__rotateClockwise",
  "sizeM": "spinner-module-scss-module__cxcG8G__sizeM",
  "sizeS": "spinner-module-scss-module__cxcG8G__sizeS",
  "sizeXl": "spinner-module-scss-module__cxcG8G__sizeXl",
  "sizeXs": "spinner-module-scss-module__cxcG8G__sizeXs",
  "spinner": "spinner-module-scss-module__cxcG8G__spinner",
  "spinnerFixed": "spinner-module-scss-module__cxcG8G__spinnerFixed",
  "spinnerOverlay": "spinner-module-scss-module__cxcG8G__spinnerOverlay",
  "spinnerOverlayAbsolute": "spinner-module-scss-module__cxcG8G__spinnerOverlayAbsolute",
  "spinnerOverlayFixed": "spinner-module-scss-module__cxcG8G__spinnerOverlayFixed",
  "success": "spinner-module-scss-module__cxcG8G__success",
  "warning": "spinner-module-scss-module__cxcG8G__warning",
});
